var OrgTypes = require("lib/academic/OrgTypes");

export function getPath(state) {
	var fullPath = "/roster";

	if (state.activeView) {
		fullPath += "/" + state.activeView;
		if (state.orgIdentifier)  {
			fullPath += "/" + state.orgIdentifier;
		}
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};

	if (params.active_view) {
		state.activeView = params.active_view;
		if (params.org_identifier)  {
			state.orgIdentifier = params.org_identifier;
		} else {
			state.orgIdentifier = OrgTypes.ALL_STUDENTS_IDENTIFIER;
		}
	} else {
		state.activeView = VIEWS.ROSTER;
		state.orgIdentifier = OrgTypes.ALL_STUDENTS_IDENTIFIER;
	}

	return state;
}

export var PATH = "/roster/:active_view?/:org_identifier?";

export var VIEWS = {
	ROSTER: "roster",
	GOALS: "goals",
	LEVELS: "levels"
}


// WEBPACK FOOTER //
// ./modules/lib/routing/RosterRouting.js